"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>InputLimiter
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
require("react");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_pcln_icons_namespaceObject = require("pcln-icons");
const index_js_namespaceObject = require("../../constants/index.js");
const InputLimiter_InputLimiter = ({ currentLength })=>{
    const { MAXLENGTH, WARNLENGTH } = index_js_namespaceObject.messageInputConfig;
    const exceedsMaxLength = currentLength >= MAXLENGTH;
    const exceedsWarnLength = currentLength >= WARNLENGTH;
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
        children: [
            exceedsWarnLength && !exceedsMaxLength && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Flex, {
                pl: "12px",
                justifyContent: "flex-start",
                pt: 1,
                id: "inputLimiterWarn",
                "data-testid": "inputLimiterWarn",
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                        mr: 1,
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_icons_namespaceObject.InformationOutline, {
                            size: 16,
                            color: external_pcln_design_system_namespaceObject.theme.colors.lightText
                        })
                    }),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Text, {
                            mt: "1px",
                            textStyle: "caption",
                            color: external_pcln_design_system_namespaceObject.theme.colors.lightText,
                            children: [
                                ' ',
                                currentLength,
                                " of ",
                                MAXLENGTH,
                                " character limit."
                            ]
                        })
                    })
                ]
            }),
            exceedsMaxLength && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Flex, {
                pl: "12px",
                justifyContent: "flex-start",
                pt: 1,
                id: "inputLimiterExceed",
                "data-testid": "inputLimiterExceed",
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                        mr: 1,
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_icons_namespaceObject.InformationOutline, {
                            size: 16,
                            color: external_pcln_design_system_namespaceObject.theme.colors.red
                        })
                    }),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Text, {
                            mt: "1px",
                            textStyle: "caption",
                            color: external_pcln_design_system_namespaceObject.theme.colors.red,
                            children: [
                                ' ',
                                "Character limit of ",
                                MAXLENGTH,
                                " reached."
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
const InputLimiter = InputLimiter_InputLimiter;
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
